import styled from "styled-components";
import {makeStyles} from "@material-ui/core/styles";
import Background from "../../assets/login/background.jpg";
import BackgroundSGP from "../../assets/login/background_sgp.jpg";
import {lgDown, smDown} from "../../ui/common";
import QnectButton from "../qnect-ui/qnect-button";
import SwipeableViews from "react-swipeable-views";
import SearchIcon from '../../assets/Search.svg';
import ArrowDownIcon from '../../assets/Unfold.svg';
import ArrowUpIcon from '../../assets/Fold.svg';
import EditIcon from '../../assets/Edit.svg';
import DeleteIcon from '../../assets/Delete.svg';
import PagingLeftFullIcon from '../../assets/PagingLeftFull.svg';
import PagingLeftIcon from '../../assets/PagingLeft.svg';
import PagingRightFullIcon from '../../assets/PagingRightFull.svg';
import PagingRightIcon from '../../assets/PagingRight.svg';

export const PageTitleDiv = styled.div`
    margin-top: 50px;
    margin-bottom: 30px;
    & > span {
      font-family: Stag-Medium;
      font-size: 30px;
      font-weight: black;
      color: #0A1F44;
    }
`;

export const RequestTrackingTable = styled.div`
    width: 1250px;
    font-family: 'Inter-Regular', 'Inter Regular', 'Inter', sans-serif;
    font-size: 12px;
    margin: 0 auto 20px;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.8);
    box-shadow: 2px 2px 8px 0 rgba(20,40,75,0.2);
    border: 1px solid #eee;
    margin-bottom: 50px;

    @media (max-width: 1251px) and (min-width: 1024px) {
      width: 100%;
    }

    & > table {
      width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      & th, td {
        border-bottom: 1px solid #ccc;
      }
      & tr:last-child td {
        border-bottom: 0;
      }
      & th {
        padding: 25px 20px;
      }
      & td {
        padding: 20px;
      }
      & th:first-child, td:first-child {
        width: 17%;
      }
      & th:nth-child(2), td:nth-child(2) {
        width: 17%;
      }
      & th:nth-child(3), td:nth-child(3) {
        width: 17%;
      }
      & th:last-child, td:last-child {
        width: 49%;
      }
      & th {
        text-align: left;
      }
      & a {
        color: #003DA5;
        text-decoration: none;
      }
      & > caption {
        text-align: right;
        padding: 30px;
        border-bottom: 1px solid #999;
      }
    }
    & .MuiTableRow-head span {
      font-size: 12px;
      font-family: 'Inter-Regular', 'Inter Regular', 'Inter', sans-serif;
      font-weight: bold;
      text-transform: uppercase;
    }
    & .MuiPaper-elevation2 {
      box-shadow: none;
      border-radius: 10px;
      border: 0;
      & .MuiToolbar-gutters {
        padding-left: 20px;
        padding-right: 20px;
      }
      & table.MuiTable-root tr:last-child td {
        border-bottom: 0;
        padding-bottom: 0;
      }
      & .MuiTable-root th, .MuiTable-root td {
        width: 17%;
      }
      & .MuiTable-root th:last-child, .MuiTable-root td:last-child {
        width: 49% !important;
      }
      & .MuiTableSortLabel-root {
        line-height: 20px;
      }
    }
`;

export const StyledPendingSwipeable = styled(SwipeableViews)`
  @media (max-width: 1279px) {
    padding: 0 800px 0 0;
  }
  @media (max-width: 1150px) {
    padding: 0 700px 0 0;
  }
  @media (max-width: 1080px) {
    padding: 0 600px 0 0;
  }
  @media (max-width: 959px) {
    padding: 0 500px 0 0;
  }
  @media (max-width: 849px) {
    padding: 0 400px 0 0;
  }
  @media (max-width: 759px) {
    padding: 0 300px 0 0;
  }
  @media (max-width: 650px) {
    padding: 0 200px 0 0;
  }
  @media (max-width: 550px) {
    padding: 0 100px 0 0;
  }
  @media (max-width: 450px) {
    padding: 0 100px 0 0;
  }
  @media (max-width: 450px) {
    padding: 0 20px 0 0;
  }
`;

export const StyledSwipeable = styled(StyledPendingSwipeable)`
  @media (max-width: 1279px) {
    padding: 0 700px 0 0;
  }
  @media (max-width: 1080px) {
    padding: 0 600px 0 0;
  }
  @media (max-width: 959px) {
    padding: 0 500px 0 0;
  }
  @media (max-width: 849px) {
    padding: 0 400px 0 0;
  }
  @media (max-width: 759px) {
    padding: 0 300px 0 0;
  }
  @media (max-width: 650px) {
    padding: 0 200px 0 0;
  }
  @media (max-width: 550px) {
    padding: 0 100px 0 0;
  }
  @media (max-width: 450px) {
    padding: 0 50px 0 0;
  }
  @media (max-width: 390px) {
    padding: 0 20px 0 0;
  }
`;

export const StyledNewsSwipeable = styled(SwipeableViews)`
  @media (max-width: 1279px) {
    padding: 0 700px 0 0;
  }
  @media (max-width: 1080px) {
    padding: 0 600px 0 0;
  }
  @media (max-width: 959px) {
    padding: 0 550px 0 0;
  }
  @media (max-width: 859px) {
    padding: 0 450px 0 0;
  }
  @media (max-width: 759px) {
    padding: 0 350px 0 0;
  }
  @media (max-width: 650px) {
    padding: 0 250px 0 0;
  }
  @media (max-width: 450px) {
    padding: 0 150px 0 0;
  }
`;

const useRequestTrackingStyles = makeStyles(theme => ({

    page_container: {
        marginTop: '15px',
        width: '1250px',
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'relative',
        [theme.breakpoints.between("1024", "1250")]: {
          width: '95%',
        },
        "& .MuiToolbar-regular" : {
          borderBottom: '1px solid #8A94A6',
          minHeight: '75px',
        },
        "& .MuiInputBase-root.MuiInput-formControl" : {
          minHeight: '42px',
          minWidth: '300px',
          padding: '6px 12px 6px 20px',
          borderRadius: '5px',
          border: '0',
          color: '#455571',
          fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serif',
          fontSize: '14px',
          lineHeight: '20px',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '10px center',
          backgroundColor: '#F7F8F9',
          "& .MuiInputAdornment-positionEnd button" : {
            display: 'none',
          },
        },
        "& .MuiInputBase-root.MuiTablePagination-input" : {
          minHeight: '42px',
          border: '0',
          color: '#455571',
          fontFamily: 'Inter, Inter Regular, Inter-Regular, sans-serif',
          fontSize: '14px',
          lineHeight: '20px',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '10px center',
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before" : {
          borderBottom: '0',
        },
        "& .MuiInput-underline:before" : {
          borderBottom: '0',
        },
        "& .MuiInput-underline:after" : {
          borderBottom: '0',
        },
        "& .MuiTableBody-root" : {
          fontSize: '12px',
          "& .tableTitle" : {
            color: '#0A1F44',
          },
          "& td": {
            fontFamily: 'Inter Regular, Inter-Regular, Inter, sans-serif !important',
            fontSize: '400',
          },
        },
        "& .MuiTableCell-root" : {
          padding: '20px 25px',
        },
        "& .MuiTableFooter-root .MuiTablePagination-toolbar" : {
          minHeight: '75px',
          borderBottom: '0',
        },
    },
  

}));

export default useRequestTrackingStyles;